import { useState } from "react";
import ContentLayout from "../../components/contentLayoutClient";
import DraftTable from "../../components/table/draftTable";
import ProposalTable from "../../components/table/proposalTable";
import Modal from "../../components/modal";
import NewProposal from "../../components/modal/newProposal";
import { Navigate, useNavigate } from "react-router-dom";

const ProposalsPage = () => {
  const navigate = useNavigate()
  const [openCreateNew, setOpenCreateNew] = useState(false);
  const [openView, setOpenView] = useState(false);

  const onCraeteNewProposal = () => setOpenCreateNew((open) => !open);

  const onViewOrEdit = () => navigate('/proposals/1')

  return (
    <>
      <ContentLayout>
        
      </ContentLayout>

      <Modal isOpen={openCreateNew} onOutsideClick={onCraeteNewProposal}>
        <NewProposal onCancel={onCraeteNewProposal} />
      </Modal>
    </>
  );
};

export default ProposalsPage;
